import { PopupType } from '../../../components/popup/types';
import { crossOriginCommunicationController } from '../../../controllers/crossOriginCommunication/CrossOriginCommunicationControllerConnector';
import { OutgoingMessage } from '../../../controllers/crossOriginCommunication/types';
import type { CoreStoreType } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

export class GameCommunicationDuplicatedConnectionProcessor implements IGameCommunicationProcessor {
  messageName = 'duplicated_connection';

  process(message: GameCommunicationMessageType, store: CoreStoreType): void {
    crossOriginCommunicationController.dispatch(OutgoingMessage.ErrorMessage, {
      errorCode: '8075',
      errorMessage: 'SESSION_EXPIRED_ERROR',
    });

    store.dispatch(popupActions.overwritePopup(PopupType.LoggedOut));
    store.dispatch(gameStateActions.setGameAbandoned(true));
  }
}
